/** Destination captured by RequireAuth when it bounced a deep link to /login. */
export interface From {
  pathname: string;
  search: string;
}

/**
 * The post-login destination, forced to be somewhere inside this app.
 *
 * `from` is derived from the URL, so it is attacker-controlled: a victim sent to
 * `https://nota.lyodge.com//evil.com` reaches /login with `pathname: "//evil.com"`,
 * and react-router reinterprets a leading `//` as a protocol-relative URL
 * (GHSA-2j2x-hqr9-3h42, patched in 6.30.4) — an open redirect riding on a real
 * login. Only a single leading slash is a path; anything else falls back to /today.
 */
export function internalPath(from: From | undefined): string {
  if (!from) return '/today';
  const { pathname, search } = from;
  if (!pathname.startsWith('/')) return '/today';
  // Rejects "//host" and "/\host" — the browser reads both as another origin.
  if (pathname.startsWith('//') || pathname.startsWith('/\\')) return '/today';
  return `${pathname}${search}`;
}
